var map = {
	"./spr_banner_21bust.png": 97741,
	"./spr_banner_axethrowing.png": 16810,
	"./spr_banner_beerpong.png": 18468,
	"./spr_banner_billiards.png": 3452,
	"./spr_banner_bocce.png": 17170,
	"./spr_banner_cornhole.png": 62564,
	"./spr_banner_darts.png": 45440,
	"./spr_banner_horseshoes.png": 87129,
	"./spr_banner_other.png": 14028,
	"./spr_banner_pickleball.png": 769,
	"./spr_banner_pong.png": 34270,
	"./spr_banner_popdarts.png": 57377,
	"./spr_banner_tableshuffleboard.png": 47923,
	"./spr_banner_tabletennis.png": 94011,
	"./spr_banner_tennis.png": 98965,
	"./spr_banner_volleyball.png": 14248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83680;